// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-container{padding:50px 100px}`, "",{"version":3,"sources":["webpack://./src/components/contract/common/SubscriptionHubWarning/SubscriptionHubWarning.scss"],"names":[],"mappings":"AAAA,iBACI,kBAAA","sourcesContent":[".alert-container {\n    padding: 50px 100px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
